import React from 'react';

const GeneralSVG = (props) => {
    return (
        <div className={props.SvgWrapper}>
            {props.Svg}
            <span>{props.Label}</span>
        </div>
    )
};

export default GeneralSVG;